import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem6 = ({ branch = "CSE" }) => {
  const notes = [
    { title: 'Artificial Intelligence', link: `/notes/${branch.toLowerCase()}/Artificial_Intelligence` },
    { title: 'Programming in Python', link: `/notes/${branch.toLowerCase()}/Programming_in_Python` },
    { title: 'Principles of Management for Engineers', link: `/notes/${branch.toLowerCase()}/PME` },
    { title: 'Statistics, Statistical Modelling & Data Analytics', link: `/notes/${branch.toLowerCase()}/SSDMA` },
    { title: 'Universal Human Values', link: `/notes/${branch.toLowerCase()}/UHV-II` },
    { title: 'Web Technologies', link: `/notes/${branch.toLowerCase()}/WT` },
    { title: 'Principles of Programming Languages', link: `/notes/${branch.toLowerCase()}/PPL` }


  ];
  return (
    <SemesterLayout
      branch={branch}
      semester="6th Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem6;
